import React, {Component} from 'react';
import WaitingModal from '../../generics/WaitingModal';
import {translate} from 'react-i18next';
import { Table, Button } from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import { search } from 'react-icons-kit/icomoon/search';
import Moment from 'react-moment';
import { download3 } from 'react-icons-kit/icomoon/download3';
import { cross } from 'react-icons-kit/icomoon/cross';
import {print} from 'react-icons-kit/fa/print';
import swal from 'sweetalert';
import ModalStatus from '../modalStatus';
import ModalView from '../modalView';

import SvgIcon from 'react-icons-kit';
var Config = require('../../../config');

class Despatch extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.editUnitOrder = this.editUnitOrder.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onPrint = this.onPrint.bind(this);

		this.state = {
			submenu: "",
			results: [],
			filterText:"",

			start_date:"",
			end_date:"",
			start_folio:"",
			end_folio:"",
			option:"ENVIADO",
			status:""

		}
	}

	componentDidMount(){
		var submenu = this.state.submenu === "" ? this.props.match.path.replace('/', '') : this.state.submenu;
		this.setState({
			submenu: submenu
		});
		
		this.onSearch();
	}

	onSearch(){
		this.waiting_modal.handleShow("Cargando...");
		fetch(Config.default.apiGateway.URL+'unit_request?start_date='+this.state.start_date+
				'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio+
				'&option='+this.state.option+'&health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
				'&type=requested_to&status='+this.state.option, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Conten-Type'	: 'application/json'
			})
		}).then(res => res.json())
		.then(response=>{
			this.waiting_modal.handleClose();

			this.setState({
				results: response
			});
		});
	}

	filter(row){
		var res = true;

		if(row !== null){


			if(
				row.unit.id !== null &&
				row.unit.unit_number !== null &&
				row.blood_component.component !== null &&
				row.blood_component.code !== null &&
				row.unit.volume !== null &&
				row.status !== null
			){

				if(
					row.unit.id.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.unit_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.blood_component.component.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.blood_component.code.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.component_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.volume.indexOf(this.state.filterText.toUpperCase()) !== -1  ||
					row.status.indexOf(this.state.filterText.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	handleChange(e){
		if(e.target.name === "option"){
			this.setState({
				[e.target.name]: e.target.value
			});
			
			setTimeout(function(){
				this.onSearch();
			}.bind(this), 500);
			
		}
		this.setState({
			[e.target.name]: e.target.value
		});
			
	}

	editUnitOrder(id){
		this.props.history.push("distribution/despatch/"+id);
	}

	changeStatus(id){
		this.modal_status.handleShow(id);
	}

	viewDetails(title, id){
		this.modal_view.handleShow(title, id);
	}

	async onPrint(id, e){
    	e.preventDefault();

     	fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
     		sessionStorage.getItem("health_facilities_id")+
     		'&file_type=AREA_DISTRIBUTION&extraction_type=',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	          'Content-Type': 'application/json',
	        })
      	}).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then(function(result) {
                  swal('¡Error', result, 'error');
                });
            }
        }).then(async response => {
        	if(response.res === 0){
          		swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
        	}else{
          		this.waiting_modal.handleShow('Imprimiendo...');
          
		        var obj ={};
		        obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		        obj.id = id;
		        obj.file_type = "area_distribution";
		        obj.nEtiqueta = [0];

		         var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				}else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				}

				if(document !== undefined){
					this.waiting_modal.handleClose();
					this.setState({ show: false});
				}else{
					this.waiting_modal.handleClose();
				}

          		/*fetch(Config.default.apiGateway.URL+'html_templates/print_distribution_document', {
          			method : 'post',
            		body:JSON.stringify(obj),
            		responseType: 'blob', //Force to receive data in a Blob Format
            		headers : new Headers({
              			'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
            			'Content-Type': 'application/json'
            		})
          		}).then(res => {
            		this.waiting_modal.handleClose();
            		if(res.ok){
              			return res.blob();
            		}else{
                    	res.text().then(function(result) {
                      		swal('¡Error', result, 'error');
                      		return;
                    	});
                  	}
          		}).then(response => {
            		if(response !== undefined){
              			//PREVIEW
              			var fileURL = URL.createObjectURL(response);
                  		window.open(fileURL);
        
                  		this.setState({ show: false});
                	}
          		})*/
        	}
      	})
  	}

  	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						Inicio -> 
						Distribución ->
						Despacho de Unidades
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input className="form-control" type="date" name="start_date" id="start_date" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.start_date || ""} autoFocus={true} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input className="form-control" type="date" name="end_date" id="end_date" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.end_date || ""}  />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Folio Desde</span>
							<input className="form-control" type="text" name="start_folio" id="start_folio" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.start_folio || ""} />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Folio Hasta</span>
							<input className="form-control" type="text" name="end_folio" id="end_folio" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.end_folio || ""} />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Estatus</span>
							<select name="option" id="option" value={this.state.option || ""} 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange}
								className="form-control">
								<option value="TODOS">TODOS</option>
								<option value="ENVIADO">ENVIADO</option>
								<option value="RECHAZADA">RECHAZADA</option>
								<option value="SUMINISTRADO">SUMINISTRADO</option>
							</select>
						</div>
						<div className="col-xs-12 col-sm-1">
							<button type="button" className="btn btn-info" style={{fontSize:"1em", marginTop:"11px"}}>
								Buscar
							</button>
						</div>
					</div>
				</form>

				<hr style={{width:"95%"}} />

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Id</th>
								<th>Solicitado por</th>
								<th>Componentes</th>
								<th>Cant. Tot.</th>
								<th>Estatus</th>
								<th>Fecha y Hora</th>
								<th></th>
							</tr>
						</thead>

						<tbody>
		                 	{this.state.results.map( (item, index) => (
			                    <tr key={item.unit_request.id}>
			                      	<td>{item.unit_request.id}</td>
									<td>{item.request_to.name}</td>
									<td>{item.components}</td>
									<td>{item.amount}</td>
									<td>{item.status}</td>
									<td><Moment format="DD/MM/YYYY">{item.unit_request.date}</Moment> - {item.unit_request.hour}</td>
									<td>
										<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}}
											onClick={this.viewDetails.bind(this,'Despacho de Unidades', item.unit_request.id)}>
											<SvgIcon icon={search} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Imprimir" style={{marginRight:"5px"}}
											onClick={(e)=>this.onPrint(item.unit_request.id, e)}>
											<SvgIcon icon={print} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} onClick={this.editUnitOrder.bind(this,item.unit_request.id)}
											disabled={item.status !== 'ENVIADO'}>
											<SvgIcon icon={pencil2} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Descargar" style={{marginRight:"5px"}}
											disabled>
											<SvgIcon icon={download3} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											disabled={item.status !== 'ENVIADO'}
											onClick={this.changeStatus.bind(this,item.unit_request.id)}>
											<SvgIcon icon={cross} />
										</Button>
									</td>
			                    </tr>
		                    ))}
		                </tbody>
					</Table>
				</div>

				<ModalView {...this.props} onRef={ref => (this.modal_view = ref)}/>
				<ModalStatus {...this.props} onSearch={this.onSearch} onRef={ref => (this.modal_status = ref)}/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Despatch)
